export default __webpack_public_path__ + "static/media/bathroom1-after-1024w.b86218bd.avif";